// Name und Adresse eines Objekts – eine Stelle für alle Ansichten.

export interface ObjektKopfRoh {
  id: string;
  bezeichnung?: string | null;
  titel?: string | null;
  objektnummer?: string | null;
  strasse?: string | null;
  hausnummer?: string | null;
  plz?: string | null;
  stadt?: string | null;
  ort?: string | null;
  adresse?: string | null;
  verwaltungsart?: string | null;
  objekttyp?: string | null;
  bild_url?: string | null;
}

const sauber = (s: string | null | undefined): string => (s ?? '').trim();

/** „Alte Straße 17, 35216 Biedenkopf-Wallau“ – aus den Einzelfeldern, sonst aus adresse/ort. */
export function objektAdresse(o: ObjektKopfRoh): string {
  const strasse = [sauber(o.strasse), sauber(o.hausnummer)].filter(Boolean).join(' ');
  const ort = [sauber(o.plz), sauber(o.stadt) || sauber(o.ort)].filter(Boolean).join(' ');
  const zusammen = [strasse, ort].filter(Boolean).join(', ');
  return zusammen || sauber(o.adresse);
}

/** Anzeigename: Bezeichnung, sonst Titel, sonst Straße + Nr., sonst „Objekt“. */
export function objektName(o: ObjektKopfRoh): string {
  const strasse = [sauber(o.strasse), sauber(o.hausnummer)].filter(Boolean).join(' ');
  return sauber(o.bezeichnung) || sauber(o.titel) || strasse || 'Objekt';
}
